import React, { useState } from "react";

type Props = {
	onClick?: () => Promise<any>;
	callback?: () => void;
	className?: string;
	question?: string;
	loader?: boolean;
	waitForFinish?: boolean;
	type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
	children?;
	inputProps?;
};

const AsyncButton = ({
	onClick,
	callback,
	className = null,
	question = null,
	loader = true,
	waitForFinish = false,
	type,
	children,
	...inputProps
}: Props) => {
	const [isLoading, setLoading] = useState(false);

	if (isLoading && loader) {
		return <button className={className + " loading"} />;
	}

	return (
		<button
			{...inputProps}
			type={type}
			className={className}
			disabled={isLoading}
			onClick={async () => {
				let confirmed = true;
				if (question) {
					confirmed = window.confirm(question);
				}

				if (confirmed) {
					if (loader) {
						setLoading(true);
					}
					if (onClick) {
						await onClick();
					}
					if (callback) {
						callback();
					}
					if (loader && waitForFinish) {
						setLoading(false);
					}
				}
			}}
		>
			{children}
		</button>
	);
};

export default AsyncButton;
